const RemoteService = angular.module('remote', [])
  .service('laboxRemote',  ['$http',function ($http) {

    this.isUp = (event)=>{
      return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
    };

    this.isDown = (event)=>{
      return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
    };

    this.isRight = (event)=>{
      return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
    };

    this.isLeft = (event)=> {
      return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
    };

    this.isEnter = (event)=> {
      return event.code === 'Enter' || event.keyIdentifier === 'Enter' || event.charCode === 13;
    };

    this.isTab = (event)=> {
      return event.code === 'Tab' && !event.shiftKey;
    };

    this.isShiftTab = (event)=> {
      return event.code === 'Tab' && event.shiftKey === true;
    };

    this.isBack = (event)=> {
      return event.keyCode === 8 || event.keyCode === 27 || event.code === 'Backspace' || event.keyCode === 461;
    };
  }]);

export default RemoteService;



// WEBPACK FOOTER //
// ./client/app/remote/remote.js